import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-responses',
    templateUrl: './responses.component.html',
    styleUrls: ['./responses.component.scss'],
    standalone: false
})
export class ResponsesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
